export const onlyNumbers = (e, limit) => {
    let { value } = e.target;

    value = value.replace(/[a-zA-Z*+-.?!´`~''""/\\]/, "");
    if (limit) {
        const regLimit = new RegExp('([0-9]{' + limit + '})(.*)');
        value = value.replace(regLimit, "$1");
    }

    e.target.value = value;
};

export const clearCharacters = (e) => {
    let { value } = e.target;

    value = value.replace(/[.\-!?_() ]/g, '');

    e.target.value = value;
};

export const cpfFormater = (e) => {
    let {value} = e.target;

    value = value.replace(/([0-9]{3})([0-9]{3})([0-9]{3})([0-9]{2})/, '$1.$2.$3-$4');
    e.target.value = value;
};

function getUrlParams() {
    const reg = new RegExp(/[&?]+([a-zA-Z0-9_-]+=[a-zA-Z0-9= -]+)/, 'g');
    const urlLocation = window.location.search.match(reg);
    const paramsMap = new Map();
    let cleanParam = null;

    if (!urlLocation) {
        return;
    }

    urlLocation.forEach(function(param){
        cleanParam = param.replace( /[?&]/, '');

        if (cleanParam.length) {
            let position = cleanParam.indexOf('='),
                key = cleanParam.substr(0, position),
                value = cleanParam.substr(position+1, cleanParam.length-1);

            paramsMap.set(key, value);
        }
    });

    return paramsMap;
};

function getUrlParam(paramName) {
    const params = this.getUrlParams();
    let foundParam = null;

    if (!params) {
        return;
    }

    if (params.has(paramName)) {
        foundParam = params.get(paramName);
    }
    return foundParam;
};

export const URL = {
    getUrlParams,
    getUrlParam
};



// WEBPACK FOOTER //
// ./src/utility/utils.js